import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { myFirebase, myFirestore } from "../../Config/firebase";
import WelcomeBoard from "../WelcomeBoard/WelcomeBoard";
import "./Main.css";
import ChatBoard from "./../ChatBoard/ChatBoard";
import { AppString, timeSince, truncateString } from "./../Const";
import ReactLoading from 'react-loading'
import { Col, Row } from "react-bootstrap";

class MainChat extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isOpenDialogConfirmLogout: false,
      currentPeerUser: null,
      currentIndex : null,
      listUsersFirebase: [],
      reload: false,
      listUser: [],
      listMapped: []
    };
    this.currentUserId = localStorage.getItem(AppString.ID);
    this.currentUserAvatar = localStorage.getItem(AppString.PHOTO_URL);
    this.currentUserNickname = localStorage.getItem(AppString.NICKNAME);
    this.listUser = [];
    this.listMessages = [];
  }

  componentDidMount() {
    this.checkLogin();
  }

  checkLogin = () => {
    if (!localStorage.getItem(AppString.ID)) {
      this.setState({ isLoading: false }, () => {
        this.props.history.push("/");
      });
    } else {
      this.getListUser();
      this.getListUserFirebase();
      const userId = window.location.search;
      setTimeout(() => {
        try {
          const isNull = document.getElementById(userId?.replace('?userId=', ''));
          if (isNull) document.getElementById(userId?.replace('?userId=', '')).click();
        } catch (err) {
          console.log('err', err);
        }
      }, 1500);
    }
  };

  getListUser = async () => {
    const result = await myFirestore
      .collection(AppString.NODE_LOADS)
      .where("shipperId", "==", this.currentUserId)
      .get();
    if (result.docs.length > 0) {
      this.listUser = [...result.docs];
      this.setState({ isLoading: false, listUser: [...result.docs] });
    }
  };
  getListUserFirebase = async () => {
    const result = await myFirestore.collection(AppString.NODE_USERS).get();
    if (result.docs.length > 0) {
      const resultList = [...result.docs];
      const listCc = [];
      resultList.forEach((x) => {
        listCc.push({
          nickname: x.data().nickname,
          id: x.data().id,
          photoUrl: x.data().photoUrl,
          pushToken: x.data().pushToken,
        });
      });
      this.setState({ listUsersFirebase: listCc });
    }
  };
  // getLastMessage = async (peerUserId) => {
  //     const resultMessages = await myFirestore
  //     .collection(AppString.NODE_MESSAGES)
  //     .doc(`${this.currentUserId}-${peerUserId}`)
  //     .collection(`${this.currentUserId}-${peerUserId}`)
  //     .get()
  //     if (resultMessages.docs.length > 0) {
  //        return [...resultMessages.docs]
  //     }
  // }
  fetchSearch = async (search) => {
    try {
      const result = await myFirestore.collection(AppString.NODE_USERS).get();
      const loads = await myFirestore
        .collection(AppString.NODE_LOADS)
        .where("shipperId", "==", this.currentUserId)
        .get();

      const listUser = [...result.docs];
      const listLoads = [...loads.docs];
      const listUserNickname = [];
      listLoads.forEach((x) => {
        listUser.find((y) => {
          if (x.data().userId === y.data().id) {
            if (
              y
                .data()
                .nickname?.toLowerCase()
                .includes(search?.toLowerCase()) ||
              String(x
                .data()
                .id).toLowerCase()
                .includes(search?.toLowerCase())
            ) {
              listUserNickname.push(x);
            }
          }
          return null;
        });
      });
      this.setState({ listUser: listUserNickname });
    } catch (err) {
      console.log(err);
    }
  };
  onLogoutClick = () => {
    this.setState({
      isOpenDialogConfirmLogout: true,
    });
  };

  doLogout = () => {
    this.setState({ isLoading: true });
    myFirebase
      .auth()
      .signOut()
      .then(() => {
        this.setState({ isLoading: false }, () => {
          localStorage.clear();
          // this.props.showToast(1, "Logout success");
          // this.props.history.push("/");
        });
      })
      .catch(function (err) {
        this.setState({ isLoading: false });
        this.props.showToast(0, err.message);
      });
  };

  hideDialogConfirmLogout = () => {
    this.setState({
      isOpenDialogConfirmLogout: false,
    });
  };

  onProfileClick = () => {
    this.props.history.push("/profile");
  };

  renderListUser = () => {
    if (this.state?.listUser?.length > 0) {
      const resultArray = this.state?.listUser;
      let list = [];
      resultArray.forEach(s => {
        list.push({
          id: s.data().id,
          nickname: s.data().nickname,
          date: s.data().date,
          userId: s.data().userId,
          shipperId: s.data().shipperId,
          lastMessage: s.data().lastMessage,
          isReadWeb: s.data().isReadWeb,
          data: s.data(),
          timestamp : s.data().timestamp
        });
      });
      list = list.sort(function(a, b) {
        return b.timestamp - a.timestamp;
      });
      let viewListUser = [];
      list
        .forEach((item, index) => {
          if (item?.userId !== this.currentUserId) {
            viewListUser.push(
              item?.nickname !== "" &&
              item?.nickname !== undefined &&
              item?.nickname !== null && (
                <Fragment key={index}>
                  <span
                    onClick={async () => {
                      //Save Last Message
                      try {
                        myFirestore
                          .collection(AppString.NODE_LOADS)
                          .doc(`${item?.id}-${item?.userId}-${item?.shipperId}`)
                          .update({
                            isReadWeb: true,
                          })
                          .then((data) => {
                            console.log(data);
                          });
                      } catch (err) {
                        console.error("err", err);
                      }
                      setTimeout(() => {
                        this.getListUser();
                        this.getListUserFirebase();
                        this.setState({
                          currentPeerUser: undefined,
                          currentIndex : null,
                          reload: true,
                        });
                        this.setState({
                          currentPeerUser: item?.data,
                          currentIndex : index,
                          reload: false,
                        });
                      }, 500);
                    }}
                    id={item?.id + "-" + item?.userId}
                    style={{ cursor: 'pointer' }}
                  >
                    <div
                      className={`${this.state.currentPeerUser && this.state.currentIndex !== null && 
                        this.state.currentIndex === index
                        ? "activeUser"
                        : "pl-2"
                        } d-flex flex-stack py-4 pl-2 border-bottom itemUserChat`}
                      // style={{ whiteSpace: 'nowrap' }}
                    >
                      <div className="d-flex align-items-center">

                        {this.state.listUsersFirebase?.find(
                          (x) => x?.id === item?.userId
                        )?.photoUrl ? (
                          <div className="symbol symbol-45 symbol-lg-50 symbol-circle">
                            <img
                              className="viewAvatarItem"
                              src={
                                this.state.listUsersFirebase?.find(
                                  (x) => x?.id === item?.userId
                                )?.photoUrl
                              }
                              alt="icon avatar"
                            />
                          </div>
                        ) : (
                          <div className="symbol symbol-45 symbol-lg-50 symbol-circle">
                            <span
                              className={
                                "symbol-label bg-light-danger text-danger fs-6 font-weight-boldest"
                              }
                            >
                              {this.state.listUsersFirebase?.find(
                                (x) => x.id === item.userId
                              )?.nickname?.length > 0
                                ? this.state.listUsersFirebase?.find(
                                  (x) => x.id === item.userId
                                )?.nickname[0]
                                : "U"}
                            </span>
                          </div>
                        )}

                        <div className="ml-5">
                          <span
                            onClick={async () => {
                              //Save Last Message
                              try {
                                myFirestore
                                  .collection(AppString.NODE_LOADS)
                                  .doc(`${item?.id}-${item?.userId}-${item?.shipperId}`)
                                  .update({
                                    isReadWeb: true,
                                  })
                                  .then((data) => {
                                    console.log(data);
                                  });
                              } catch (err) {
                                console.error("err", err);
                              }
                              this.getListUser();
                              this.getListUserFirebase();
                              this.setState({
                                currentPeerUser: undefined,
                                reload: true,
                              });
                              setTimeout(() => {
                                this.setState({
                                  currentPeerUser: item?.data,
                                  reload: false,
                                });
                              }, 500);
                            }}
                            id={item?.userId}
                            className={
                              "font-size-h5 text-dark-75  mb-2 " +
                              (!item?.isReadWeb ? "font-weight-bolder" : "")
                            }
                          >
                            {
                              this.state.listUsersFirebase?.find(
                                (x) => x.id === item?.userId
                              )?.nickname
                            }{" "}
                            {`(#${item?.id})`}
                          </span>
                          <div className={"text-muted pt-2 " +
                              (!item.isReadWeb ? "font-weight-bolder" : "") }>
                            {item?.lastMessage?.includes('https://firebasestorage.googleapis.com') ? (
                              <Fragment>
                                <i className="flaticon2-image-file text-muted mr-2"></i>
                                <span>Image</span>
                              </Fragment>
                            ) : truncateString(item?.lastMessage, 35)}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column align-items-end ml-2 pt-md-17 mr-4" style={{ whiteSpace: 'nowrap' }}>
                        <span className="text-muted fs-7 mb-1">{timeSince(item?.timestamp)}</span>
                        {item?.isReadWeb === false && (
                          <span className="badge-sm badge-circle badge-light-success sec2 counter counter-lg"></span>
                        )}
                      </div>
                    </div>
                  </span>
                </Fragment>
              )
            );
          }
        });
      //   let url = window.location.search;
      //   url = url.replace('?userId=','');
      //     const currentItem = list.find(s => s.userId === url);
      // setTimeout(() => {
      //   try{
      //     document.getElementById(currentItem.id + '-' + currentItem.userId).click();
      //   }catch(err) {}
      // },5000)
      return viewListUser;
    } else {
      return (
        <Row className="mt-md-12">
          <Col style={{ textAlign: 'center' }}>
            <h4 className="text-muted">No users to chat with.</h4>
          </Col>
        </Row>
      );
    }
  };

  render() {
    return (
      <>
        <div className="d-flex flex-column flex-lg-row">
          <div className="flex-column flex-lg-row-auto w-100 w-lg-350px w-xl-450px mb-10 mb-lg-0">
            <div className="card card-flush">
              <div className="card-header pt-7">
                <form className="w-100 position-relative" autoComplete="off" onSubmit={e => e.preventDefault()}>
                  <span className="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-40 ml-5 translate-middle">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <rect
                        opacity="0.5"
                        x="17.0365"
                        y="15.1223"
                        width="8.15546"
                        height={2}
                        rx={1}
                        transform="rotate(45 17.0365 15.1223)"
                        fill="currentColor"
                      />
                      <path
                        d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                  <input
                    type="text"
                    className="form-control form-control-solid px-15"
                    name="search"
                    placeholder="Search by username or email..."
                    onChange={(e) => {
                      this.fetchSearch(e.target.value);
                    }}
                  />
                </form>
              </div>
              <div className="card-body p-4">
                <div
                  className="scroll-y h-300px h-lg-650px"
                >
                  {this.state.reload === false ? (
                    this.renderListUser()
                  ) : (
                    <div className="viewLoading">
                      <ReactLoading
                        type={"spin"}
                        color={"#203152"}
                        height={"3%"}
                        width={"3%"}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="flex-lg-row-fluid ml-lg-7 ml-xl-10">
            {this.state.currentPeerUser ? (
              <ChatBoard
                currentPeerUser={this.state.currentPeerUser}
                showToast={this.props.showToast}
                usersList={this.state.listUsersFirebase}
                currentUserFirebase={this.state.listUsersFirebase?.find(
                  (x) => x.id === this.state.currentPeerUser.userId
                )}
              />
            ) : this.state.currentPeerUser === undefined ? (
              <div className="card card-custom card-stretch">
                <div className="card-body">
                  <div
                    className="scroll-y mr-n5 pr-5 h-550px mb-5"
                    style={{ maxHeight: "619px" }}
                  >
                    <div className="d-flex flex-column align-items-center">
                      <div className="viewLoading">
                        <ReactLoading
                          type={"spin"}
                          color={"#203152"}
                          height={"3%"}
                          width={"3%"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <WelcomeBoard
                currentUserNickname={this.currentUserNickname}
                currentUserAvatar={this.currentUserAvatar}
              />
            )}
          </div>
        </div>

        {/* Dialog confirm */}
        {this.state.isOpenDialogConfirmLogout ? (
          <div className="viewCoverScreen">
            {this.renderDialogConfirmLogout()}
          </div>
        ) : null}

        {/* Loading */}
        {/* {this.state.isLoading ? (
                    <div className="viewLoading">
                        <ReactLoading
                            type={'spin'}
                            color={'#203152'}
                            height={'3%'}
                            width={'3%'}
                        />
                    </div>
                ) : null} */}
      </>
    );
  }

  renderDialogConfirmLogout = () => {
    return (
      <div>
        <div className="viewWrapTextDialogConfirmLogout">
          <span className="titleDialogConfirmLogout">
            Are you sure to logout?
          </span>
        </div>
        <div className="viewWrapButtonDialogConfirmLogout">
          <button className="btnYes" onClick={this.doLogout}>
            YES
          </button>
          <button className="btnNo" onClick={this.hideDialogConfirmLogout}>
            CANCEL
          </button>
        </div>
      </div>
    );
  };
}

export default withRouter(MainChat);
